import { IGameState } from 'State/Game/IGameState';
import { PlayerUnlock, UnlockType } from './IPlayerState';

export function isUnlocked(state: IGameState, unlockType: UnlockType): boolean {
    return state.playerState.playerUnlocks.some(unlock => unlock.type === unlockType);
}

export function unlock(state: IGameState, playerUnlock: PlayerUnlock) {
    return setUnlocks(state, [...state.playerState.playerUnlocks, playerUnlock]);
}

export function setUnlocks(state: IGameState, unlocks: PlayerUnlock[]) {
    return {
        ...state,
        playerState: {
            ...state.playerState,
            playerUnlocks: [...unlocks],
        },
    };
}
